<div class="tw:flex tw:flex-col tw:gap-3 tw:w-full">
  <div class="tw:flex tw:items-center tw:gap-2">
    <input type="search" class="fc-search tw:flex-1"
           placeholder="Buscar no acervo pelo nome do arquivo" aria-label="Buscar no acervo do ForestCloud"
           [value]="q()" (keyup.enter)="search($any($event.target).value)" (search)="search($any($event.target).value)" />
    <span class="tw:text-muted-foreground small">{{ total() }} arquivo(s) recebido(s)</span>
    <a class="fc-page" [href]="openInForestCloudUrl()" target="_blank" rel="noopener" title="Abrir o acervo deste projeto no ForestCloud">Abrir no ForestCloud</a>
  </div>

  @if (error()) {
    <p class="text-danger small tw:mb-0" data-testid="fc-error">{{ error() }}</p>
  } @else if (!loading() && items().length === 0) {
    <p class="tw:text-muted-foreground small tw:mb-0" data-testid="fc-empty">{{ reason() || 'Nenhum arquivo recebido para este projeto no ForestCloud.' }}</p>
  } @else {
    <ul class="fc-list">
      @for (f of items(); track f.ref) {
        <li data-testid="fc-row" class="fc-item" [class.fc-item-blocked]="!canPick(f)">
          <div class="fc-item-main">
            <div class="fc-item-name">{{ f.display_name || f.name }}</div>
            @if (f.display_name) { <div class="fc-item-meta fc-mono">{{ f.name }}</div> }
            <div class="fc-item-meta">
              <span class="fc-mono">{{ f.format || '—' }}</span> · <span class="fc-mono">{{ size(f.size_bytes) }}</span> · {{ f.sender_name }} · {{ f.received_at | date: 'dd/MM/yyyy HH:mm' }}@if (f.crs) { · CRS <span class="fc-mono">{{ f.crs }}</span> }
            </div>
            @if (why(f); as reason) { <div class="fc-item-meta text-warning">{{ reason }}</div> }
            @if (importedText(f); as imported) { <div class="fc-item-meta fc-imported" data-testid="fc-imported">{{ imported }}</div> }
          </div>
          <button type="button" data-testid="fc-pick" class="fc-pick" [disabled]="!canPick(f) || busy()" (click)="pick(f)">
            @if (busy()) { <span class="fc-spin" aria-hidden="true"></span> }
            {{ busy() ? 'Abrindo…' : 'Importar' }}
          </button>
        </li>
      }
    </ul>
    @if (pages() > 1) {
      <div class="tw:flex tw:items-center tw:justify-between tw:gap-2 tw:text-muted-foreground small" data-testid="fc-pagination">
        <span>{{ (page() - 1) * perPage + 1 }}–{{ (page() - 1) * perPage + items().length }} de {{ total() }}</span>
        <span class="tw:flex tw:items-center tw:gap-2">
          <button type="button" class="fc-page" [disabled]="page() <= 1 || loading()" (click)="goTo(page() - 1)">Anterior</button>
          <span>página {{ page() }}/{{ pages() }}</span>
          <button type="button" class="fc-page" [disabled]="page() >= pages() || loading()" (click)="goTo(page() + 1)">Próxima</button>
        </span>
      </div>
    }
  }
  @if (loading()) { <p class="tw:text-muted-foreground small tw:mb-0">Carregando…</p> }
</div>
